import React, { useEffect, useState } from 'react'
import { Platform, View, Image, Text, StyleSheet, TouchableOpacity, useWindowDimensions } from 'react-native';
import Animated, { interpolate, concat, Easing, useCode, Value, block, cond, eq, call, set, clockRunning, startClock, stopClock, timing, debug, not, multiply, Extrapolate, color, interpolateColors } from 'react-native-reanimated';
import { useClock, useValue, delay } from 'react-native-redash/lib/module/v1';
//import { SafeAreaView } from 'react-native-safe-area-context';
//import { useWindowDimensions } from '../components/Utility';
import { createStackNavigator } from '@react-navigation/stack';
import { headerStyles, LogoTitle } from '../components/LogoTitle';
import { Kratka } from '../components/Kratka';
import { Stopka } from '../components/Stopka';
import * as Obrazy from "../components/Obrazy";
import { ScrollView } from 'react-native-gesture-handler';

const pytania = [
  {
    pytanie: "Jakie imię na chrzcie święym otrzymała św. Urszula?",
    odpowiedzi: [ "Julia", "Katarzyna", "Maria", ],
    prawidlowa: 0,
    
  },
  {
    pytanie: "W czasie jakich świąt przyszła na świat Julia?",
    odpowiedzi: [ "w Boże Narodzenie", "w Poniedziałek Wielkanocny", "w Wielki Piątek", ],
    prawidlowa: 1,
  },
  {
    pytanie: "W jakim kraju urodziła się Julia?",
    odpowiedzi: [ "w Polsce", "w Austrii", "w Rosji", ],
    prawidlowa: 1,
  },
  {
    pytanie: "Jakiej narodowości byli rodzice Św. Urszuli?",
    odpowiedzi: [ "matka była Polką, a ojciec Rosjaninem", "oboje byli Polakami", "ojciec Antoni był z pochodzenia Polakiem, a matka Józefina była Szwajcarką", ],
    prawidlowa: 2,
  },
  {
    pytanie: "Jak bliscy nazywali małą Julię?",
    odpowiedzi: [ "Słoneczkiem", "Promykiem słonecznym", "Słonecznikiem", ],
    prawidlowa: 1,
  },
  {
    pytanie: "Kiedy Julia przyjechała z rodzicami do Polski, zamieszkali w Małopolsce. W jakiej miejscowości?",
    odpowiedzi: [ "w Lipnicy Murowanej k. Bochni niedaleko Krakowa", "w Krakowie", "w Pniewach", ],
    prawidlowa: 0,
  },
  {
    pytanie: "Ile lat miała Julia, gdy wstąpiła do klasztoru sióstr urszulanek w Krakowie?",
    odpowiedzi: [ "18 lat", "21 lat", "24 lata", ],
    prawidlowa: 1,
  },
  {
    pytanie: "Gdzie znajduje się Dom Macierzysty Zgromadzenia?",
    odpowiedzi: [ "w Pniewach k. Poznania", "w Rzymie", "w Poznaniu", ],
    prawidlowa: 0,
  },
  {
    pytanie: "Gdzie zmarła Urszula Ledóchowska?",
    odpowiedzi: [ "w Rzymie", "w Krakowie", "w Pniewach", ],
    prawidlowa: 0,
  },
  {
    pytanie: "Matka Urszula zmarła w Rzymie i tam została pochowana, ale później była ekshumowana i Jej relikwie obecnie znajdują się gdzie indziej. Gdzie?",
    odpowiedzi: [ "w Krakowie", "w Pniewach", "w Warszawie", ],
    prawidlowa: 1,
  },
/*
  {
    pytanie: "",
    odpowiedzi: [ "", "", "", ],
    prawidlowa: ,
  },
*/
];

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: "100%",
        height: "100%",
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    },
    pytanieContainer: {
        marginHorizontal: "10%",
        alignItems: 'flex-start',
        justifyContent: 'center',
    },
    pytanie: {
        textAlign: 'justify',
        fontFamily: 'CenturyGothic-Italic',
        fontWeight: 'normal',
        //fontStyle: 'italic',
        fontSize: ( Platform.OS === "web" ) ? 36 : 18,
        paddingVertical: "1%",
    },
    pytanieNr: {
      textAlign: 'justify',
      fontFamily: 'CenturyGothic-Bold',
      fontWeight: 'normal',
      //fontStyle: 'italic',
      fontSize: ( Platform.OS === "web" ) ? 36 : 18,
      paddingVertical: "1%",
    },
    wynik: {
      textAlign: 'justify',
      fontFamily: 'CenturyGothic-Regular',
      fontWeight: 'normal',
      //fontStyle: 'italic',
      fontSize: ( Platform.OS === "web" ) ? 36 : 18,
      paddingVertical: "1%",
    },
    bold: {
      fontFamily: 'CenturyGothic-Bold',
    },
});


const DURATION_IN = 1500;
const DURATION_OUT = 500;

function runTiming(clock, value, dest, duration) {
    const state = {
      finished: new Value(0),
      position: new Value(0),
      time: new Value(0),
      frameTime: new Value(0),
    };
  
    const config = {
      duration,
      toValue: new Value(dest),
      easing: Easing.inOut(Easing.ease),
    };
  
    return block([
      cond(
        not(clockRunning(clock)),
        [
          set(state.position, value),
          startClock(clock),
        ]
      ),
      // we run the step here that is going to update position
      timing(clock, state, config),
      // if the animation is over we stop the clock
      cond(state.finished, stopClock(clock)),
      // we make the block return the updated position
      state.position,
    ]);
}

const AnimatedText = Animated.createAnimatedComponent(Text);

const Quiz = ({navigation, route}) => {
  const windim = useWindowDimensions();
  const clock = useClock();
  const clockP = useClock();
  const opacity = useValue(0);
  const parentOpacity = useValue(1);
  const fade = new Value(0);
  const [ nrPytania, setNrPytania ] = useState(0);
  const [ wynik, setWynik ] = useState({punkty: 0, udzielono: -1});
  const finish = useValue(0);
  const colorClock = useClock();
  const c1 = useValue(0);
  const c2 = useValue(0);
  const c3 = useValue(0);
  const c1v = useValue(0);
  const c2v = useValue(0);
  const c3v = useValue(0);

  function fontSize(size) {
    return Math.floor(size * ( windim.width > windim.height ? windim.width : windim.height ) / (Platform.OS === "web" ? 1600 : 1200));
  }

  const kolejnePytanie = ([f]) => {
    //console.log("kolejnePytanie", f);
    if ( ( nrPytania + 1 ) < pytania.length )
    {
      setNrPytania((nrPytania + 1 ) % pytania.length);
    }
    else
    {
      //console.log("wynik: ", wynik);
      setNrPytania(pytania.length);
    }
  };

  useCode(() => [
    cond(
      eq(c1v, 1),
      [
        set(c1, runTiming(colorClock, 0, 0.1, DURATION_OUT)),
        cond(not(clockRunning(colorClock)), delay(set(fade, 1), DURATION_IN))
      ]
    ),
    cond(
      eq(c1v, -1),
      [
        set(c1, runTiming(colorClock, 0.2, 0.3, DURATION_OUT)),
        cond(not(clockRunning(colorClock)), delay(set(fade, 1), DURATION_IN))
      ]
    ),
    cond(
      eq(c2v, 1),
      [
        set(c2, runTiming(colorClock, 0, 0.1, DURATION_OUT)),
        cond(not(clockRunning(colorClock)), delay(set(fade, 1), DURATION_IN))
      ]
    ),
    cond(
      eq(c2v, -1),
      [
        set(c2, runTiming(colorClock, 0.2, 0.3, DURATION_OUT)),
        cond(not(clockRunning(colorClock)), delay(set(fade, 1), DURATION_IN))
      ]
    ),
    cond(
      eq(c3v, 1),
      [
        set(c3, runTiming(colorClock, 0, 0.1, DURATION_OUT)),
        cond(not(clockRunning(colorClock)), delay(set(fade, 1), DURATION_IN))
      ]
    ),
    cond(
      eq(c3v, -1),
      [
        set(c3, runTiming(colorClock, 0.2, 0.3, DURATION_OUT)),
        cond(not(clockRunning(colorClock)), delay(set(fade, 1), DURATION_IN))
      ]
    ),
    // fadeout wywołany przez odpowiedź
    cond(
      eq(fade, 1),
      [
        set(parentOpacity, runTiming(clockP, parentOpacity, 0, DURATION_OUT)),
        cond(eq(parentOpacity, 0), [call([finish], kolejnePytanie), set(finish, 1)]),
      ],
    ),
    // fadein przy nowym pytaniu
    cond(
      eq(fade, 0),
      [
        set(opacity, runTiming(clock, opacity, 1, DURATION_IN)),
      ]
    ),
    // nowe pytanie, zresetuj wartości początkowe
    cond(eq(finish, 1), [
      set(finish, 0),
      set(opacity, 0),
      set(parentOpacity, 1),
      set(c1v, 0),
      set(c2v, 0),
      set(c3v, 0),
      set(c1, 0),
      set(c2, 0),
      set(c3, 0),
    ]),
  ],[nrPytania]); // odtworzenie kodu przy zmianie numeru pytania

  const transX1 = interpolate(opacity, { inputRange: [0, 0.5], outputRange: [windim.width, 0], extrapolate: Extrapolate.CLAMP});
  const transX2 = interpolate(opacity, { inputRange: [0.25, 0.75], outputRange: [windim.width, 0], extrapolate: Extrapolate.CLAMP});
  const transX3 = interpolate(opacity, { inputRange: [0.5, 1], outputRange: [windim.width, 0], extrapolate: Extrapolate.CLAMP});
  const rotate = concat(interpolate(opacity, { inputRange: [0, 0.25, 0.5, 0.75, 1], outputRange: [0, Math.PI / 2, Math.PI, Math.PI * 1.5, Math.PI *2]}), 'rad');
  const scale = interpolate(opacity, { inputRange: [0, 1], outputRange: [0, 1] });
  const color1 = interpolateColors(c1, { inputRange: [0, 0.1, 0.2, 0.3], outputColorRange: ["black", "green", "black", "red"]});
  const color2 = interpolateColors(c2, { inputRange: [0, 0.1, 0.2, 0.3], outputColorRange: ["black", "green", "black", "red"]});
  const color3 = interpolateColors(c3, { inputRange: [0, 0.1, 0.2, 0.3], outputColorRange: ["black", "green", "black", "red"]});

  const odpowiedz = (nr) => {
    //console.log("odpowiedz na pytanie ", nrPytania);
    if ( wynik.udzielono == nrPytania )
    {
      //console.log("już udzielono odpowiedzi");
      return;
    }
    //fade.setValue(1);
    if ( nr == pytania[nrPytania].prawidlowa )
    {
      switch ( nr )
      {
        case 0:
          c1v.setValue(1);
          break;
        case 1:
          c2v.setValue(1);
          break;
        case 2:
          c3v.setValue(1);
          break;
      }
      //console.log("odpowiedź prawidłowa");
      setWynik({punkty: wynik.punkty + 1, udzielono: nrPytania});
    }
    else
    {
      switch ( nr )
      {
        case 0:
          c1v.setValue(-1);
          break;
        case 1:
          c2v.setValue(-1);
          break;
        case 2:
          c3v.setValue(-1);
          break;
      }
      switch ( pytania[nrPytania].prawidlowa )
      {
        case 0:
          c1v.setValue(1);
          break;
        case 1:
          c2v.setValue(1);
          break;
        case 2:
          c3v.setValue(1);
          break;
      }
      //console.log("odpowiedź błędna");
      setWynik({punkty: wynik.punkty, udzielono: nrPytania});
    }
  };

  return (
    <Kratka style={[styles.container, { backgroundColor: "white" }]}>
      <ScrollView style={{ width: "100%" }} contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', alignItems: "center" }}>
        <View style={{ flexGrow: 1 }} />
        { ( nrPytania < pytania.length ) &&
        <Animated.View style={[styles.pytanieContainer, { opacity: parentOpacity }]}>
          <Animated.View style={{ opacity }}>
            <Text style={[styles.pytanieNr, { fontSize: fontSize(30) }]}>Pytanie {nrPytania + 1}.</Text>
            <Text style={[styles.pytanie, { fontSize: fontSize(30) }]}>{pytania[nrPytania].pytanie}</Text>
          </Animated.View>
          <Animated.View style={{transform: [{ translateX: transX1 }] }}>
            <TouchableOpacity onPress={() => odpowiedz(0)}><AnimatedText style={[styles.pytanie, { fontSize: fontSize(30), color: color1 }]}>a) {pytania[nrPytania].odpowiedzi[0]}</AnimatedText></TouchableOpacity>
          </Animated.View>
          <Animated.View style={{transform: [{ translateX: transX2 }] }}>
            <TouchableOpacity onPress={() => odpowiedz(1)}><AnimatedText style={[styles.pytanie, { fontSize: fontSize(30), color: color2 }]}>b) {pytania[nrPytania].odpowiedzi[1]}</AnimatedText></TouchableOpacity>
          </Animated.View>
          <Animated.View style={{transform: [{ translateX: transX3 }] }}>
            <TouchableOpacity onPress={() => odpowiedz(2)}><AnimatedText style={[styles.pytanie, { fontSize: fontSize(30), color: color3 }]}>c) {pytania[nrPytania].odpowiedzi[2]}</AnimatedText></TouchableOpacity>
          </Animated.View>
        </Animated.View>
        }
        { ( nrPytania == pytania.length ) &&
          <AnimatedText style={[{ opacity, transform: [{ scale }, { rotate }] }, styles.wynik, { fontSize: fontSize(40) }]}>Twój wynik: <Text style={styles.bold}>{wynik.punkty} / {pytania.length}</Text></AnimatedText>
          // style={{ opacity, transform: [{ scale }, { rotate }] }}
        }
        <View style={{ flexGrow: 1 }} />
        <Stopka />
      </ScrollView>
    </Kratka>
  );
}

export default Quiz;